export default __webpack_public_path__ + "static/media/reset-password-v2-dark.bc2b0ee0.svg";